export default __webpack_public_path__ + "static/media/ROJIWhite@3x.f981a647.png";